import React from 'react';
import { node, object, string } from 'prop-types';
import cx from 'classnames';

import SliderStatic from './Slider.static';

const CLASS_ROOT = 'slider';

export default class Slider extends React.Component {
  static displayName = 'Slider';

  static propTypes = {
    /** Slider id */
    id: string,
    /** Slider special options for Tiny Slider: docs https://github.com/ganlanyuan/tiny-slider */
    sliderOptions: object,
    /** Slider pagination */
    pagination: node,
  };

  static defaultProps = {
    sliderOptions: {},
  };

  constructor(props) {
    super(props);

    this.slider = null;
  }

  componentDidMount() {
    this.slider = new SliderStatic(this.sliderRef, this.props.sliderOptions);
  }

  render() {
    const {
      className,
      children,
      id,
      sliderOptions,
      pagination,
      ...other
    } = this.props;

    const classes = cx(CLASS_ROOT, className);

    return (
      <div className={`${CLASS_ROOT}__wrapper`}>
        <div
          className={classes}
          ref={ref => {
            this.sliderRef = ref;
          }}
          data-slider
          data-slider-options={JSON.stringify(sliderOptions)}
          {...other}
        >
          {children}
        </div>
        {pagination}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Slider/Slider.js